import { Chip } from '@mui/material'
import type { SessionType } from '../../data/types'

const CONFIG: Record<
  SessionType,
  { label: string; color: string; bg: string }
> = {
  keynote: { label: 'Keynote', color: '#0075BC', bg: 'rgba(0,117,188,0.12)' },
  session: { label: 'Session', color: '#1C5580', bg: 'rgba(28,85,128,0.12)' },
  panel: { label: 'Panel', color: '#3E9BA1', bg: 'rgba(91,198,204,0.18)' },
  workshop: { label: 'Workshop', color: '#B5611A', bg: 'rgba(228,119,32,0.15)' },
  meal: { label: 'Meal', color: '#51788F', bg: 'rgba(81,120,143,0.12)' },
  networking: {
    label: 'Networking',
    color: '#3E9BA1',
    bg: 'rgba(91,198,204,0.18)',
  },
  break: { label: 'Break', color: '#707070', bg: 'rgba(112,112,112,0.12)' },
}

export default function SessionTypeChip({ type }: { type: SessionType }) {
  const c = CONFIG[type]
  return (
    <Chip
      label={c.label}
      size="small"
      sx={{
        fontWeight: 600,
        fontSize: '0.7rem',
        letterSpacing: '0.02em',
        color: c.color,
        bgcolor: c.bg,
        height: 22,
      }}
    />
  )
}
